import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import IconButton from "../../IconButton/IconButton";
import styles from "../TransparentDrawer.module.scss";
import { useNavigate } from "react-router-dom";

function CheckoutFee() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <div className={styles.paymentButtonsGroupHeader}>
        <IconButton
          iconName=""
          onClick={() => {}}
          color="primary"
          variant="text"
        />
        <p className={`body-bold-large ${styles.paymentButtonsGroupTitle}`}>
          {t("transparentDrawer.title.checkoutFee")}
        </p>
        <IconButton
          iconName="las la-times icon-big"
          onClick={() => navigate(-1)}
          color="primary"
        />
      </div>
      <div className={styles.paymentDescriptionContent}>
        <p className={`body-medium ${styles.paymentDescription}`}>
          {t("checkoutFee.description")}
        </p>
      </div>
      <Button
        onClick={() => navigate(-1)}
        label={t("transparentDrawer.button.gotIt")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default CheckoutFee;
